const FROSTED_GLASS_CLASS = 'bg-theme-white/90 backdrop-blur-xl backdrop-saturate-[3]';

/** Shared frosted-glass classes; `bg-theme-white` already follows the colour theme. */
export const useFrostedGlassClass = () => FROSTED_GLASS_CLASS;
